import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router
} from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(private authService: AuthService, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const requiredRole = route.data['role'];
        var flage;
        const currentUserRole = this.authService.getAdminRoleId();
        for (var i = 0; i < requiredRole.length; i++) {
            if (requiredRole[i] == currentUserRole) {
                flage = true;
            }
        }
        if (flage) {
            return true;
        }
        else {
            this.router.navigate(['/unauthorized']);
            return false;
        }
    }
}
